import { IDeskActivityOverviewStatsActivityTypeCounts } from '@kcftech/prometheustypescriptapiclient';
import { ACTIVITY_TYPE_COLORS } from 'pages/Dashboard/colors';
import { PieChartWithLegend } from 'pages/Dashboard/components/PieChartWithLegend';
import { useMemo } from 'react';
import { KCFColor } from 'styles/themes/KCFColor';

type ActivityTypeCounts = IDeskActivityOverviewStatsActivityTypeCounts;

export function ActivityTypes({ data }: { data: ActivityTypeCounts }) {
    const chartData = useMemo(
        () => [
            {
                name: 'Proactive',
                value: data.ProactiveCount,
                fill: ACTIVITY_TYPE_COLORS.Proactive,
            },
            {
                name: 'Corrective',
                value: data.CorrectiveCount,
                fill: ACTIVITY_TYPE_COLORS.Corrective,
            },
            {
                name: 'Predictive',
                value: data.PredictiveCount,
                fill: ACTIVITY_TYPE_COLORS.Predictive,
            },
            {
                name: 'Unknown',
                value:
                    data.TotalCount -
                    (data.ProactiveCount + data.CorrectiveCount + data.PredictiveCount),
                fill: KCFColor.blue8,
            },
        ],
        [data]
    );

    return (
        <PieChartWithLegend
            data={chartData}
            legendPosition="auto"
            legendVariant="detailed"
            innerRadius="60%"
            outerRadius="90%"
            legendIconVariant="circle"
        />
    );
}
